var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H18.0067M18 18C20.2091 18 22 16.2091 22 14C22 11.7909 20.2091 10 18 10C15.7909 10 14 11.7909 14 14C14 14.1825 14.0122 14.3621 14.0359 14.538C14.0748 14.8275 14.0942 14.9722 14.0811 15.0637C14.0675 15.1591 14.0501 15.2105 14.0031 15.2946C13.958 15.3753 13.8785 15.4549 13.7194 15.6139L10.3124 19.0209C10.1971 19.1362 10.1395 19.1939 10.0982 19.2611C10.0617 19.3208 10.0348 19.3858 10.0184 19.4538C10 19.5306 10 19.6121 10 19.7752V20.9333C10 21.3067 10 21.4934 10.0727 21.636C10.1366 21.7614 10.2386 21.8634 10.364 21.9273C10.5066 22 10.6933 22 11.0667 22H12.2248C12.3879 22 12.4694 22 12.5462 21.9816C12.6142 21.9652 12.6792 21.9383 12.7389 21.9018C12.8061 21.8605 12.8638 21.8029 12.9791 21.6876L16.3861 18.2806C16.5451 18.1215 16.6247 18.042 16.7054 17.9969C16.7895 17.9499 16.8409 17.9325 16.9363 17.9189C17.0278 17.9058 17.1725 17.9252 17.462 17.9641C17.6379 17.9878 17.8175 18 18 18Z",
    stroke: "#039855",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenKeyIcon);
export default __webpack_public_path__ + "static/media/green-key-icon.f8b48d062ad8727afd32552f861ddd31.svg";
export { ForwardRef as ReactComponent };